
import {BaseModel, attr} from "../../lib/itn-ui-kit/data";

export default class DocumentValidateModel extends BaseModel {
  static urlPath = 'documents/validate';

  @attr('json') choices;
  @attr('string') maxFileSize;
  @attr('json') validExtensions;
  @attr('json') required;
}
